import { useDispatch,useSelector} from "react-redux";
import { useEffect } from "react";
//import { itemsActions } from "../store/itemsSlice";
import { allItemsActions } from "../store/allItemsSlice";
import BagSummary from "../Components/BagSummary"
import BagItem from "../Components/BagItem"
import styles from "../Components/ProductList.module.css";
import Api from "../api/ecomApi";

const Bag = () => {  
     const dispatch = useDispatch();
     //const shopId = useSelector(store=>store.shop);     
    useEffect(() => {    
    Api.get(`all-shops-products`)
        .then((response) => {
            dispatch(allItemsActions.addInitialItems(response.data));
        })
      .catch((error) => {
        console.log(`Hello${error}`);
      });
    }, []);
  //localStorage.removeItem("cartList");
    //const item = localStorage.getItem('cartList') !=null ? JSON.parse(localStorage.getItem('cartList')) : []
  const bagIds = useSelector(store => store.bag.cartList);    
  //const items = useSelector(store => store.items);
  const items = useSelector(store => store.allItems);
  const bagItems = items.filter(item => {
    const itemIndex = bagIds.indexOf(item.id);
    return itemIndex >= 0;
  })
  // console.log(bagItems);
  // const result = bagItems.reduce((temp, curr) => {
  //   temp.push(curr.user_id);
  //   return temp;

  // },[]);
  // console.log(result); //[5,4,4]
  //let myObject = {1:[{id:2,name: "xyz"},{id:3, name:"mno"}], 2:[{id:4, name:"pqr"},{id:5, name:"hrc"}]};
  //console.log(myObject[1]);
  // let finalObj = {};
  // bagItems.forEach(element => {
  //   console.log(element);
  //   if (element.user_id in finalObj) {
  //     finalObj[element.user_id].push(element);
  //   } else {
  //     finalObj[element.user_id] = [element];

  //   }   
  // });
  // console.log(finalObj);
  // for (const property in finalObj) {
  //   console.log(property);
  //   console.log(finalObj[property]);
  // } 

     
    return (
      <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-8">
              <div className="row">
                {bagItems.map((item) => (
                  <BagItem key={item.id} item={item} />                
              ))}  
              </div>
            </div>
              <div className="col-sm-4">
                <BagSummary />
            </div>
          </div>
        </div>
        </div>        
      </>
    );
    
}
export default Bag